import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const IVA_TASA = 0.16;

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const MAYOREO_MIN = 12;
const MAYOREO_PCT = 0.12;

const unitPrice = (p, qty) =>
    qty >= MAYOREO_MIN ? Number((p.precio_usd * (1 - MAYOREO_PCT)).toFixed(2)) : p.precio_usd;

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("lr_cart") || "[]");
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("lr_cart", JSON.stringify(items));
    }, [items]);

    const addItem = (product, qty = 1) => {
        setItems((prev) => {
            const found = prev.find((i) => i.product.id === product.id);
            if (found) {
                return prev.map((i) =>
                    i.product.id === product.id ? { ...i, quantity: i.quantity + qty } : i
                );
            }
            return [...prev, { product, quantity: qty }];
        });
        setOpen(true);
    };

    const updateQty = (id, qty) => {
        if (qty <= 0) return removeItem(id);
        setItems((prev) => prev.map((i) => (i.product.id === id ? { ...i, quantity: qty } : i)));
    };

    const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product.id !== id));
    const clear = () => setItems([]);

    const { count, subtotal, iva, total, savings } = useMemo(() => {
        let count = 0,
            subtotal = 0,
            base = 0;
        items.forEach((i) => {
            const u = unitPrice(i.product, i.quantity);
            count += i.quantity;
            subtotal += u * i.quantity;
            base += i.product.precio_usd * i.quantity;
        });
        return {
            count,
            subtotal: Number(subtotal.toFixed(2)),
            // el precio del catálogo es neto: el IVA se suma y el cliente paga el total
            iva: Number((subtotal * IVA_TASA).toFixed(2)),
            total: Number((subtotal * (1 + IVA_TASA)).toFixed(2)),
            savings: Number((base - subtotal).toFixed(2)),
        };
    }, [items]);

    return (
        <CartContext.Provider
            value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, iva, total, savings, open, setOpen, unitPrice, MAYOREO_MIN, IVA_TASA }}
        >
            {children}
        </CartContext.Provider>
    );
};
